import React from "react";
import {
  useHistory
} from 'react-router-dom';

export default function Logout() {
    let history = useHistory();
    localStorage.removeItem("token");
    localStorage.removeItem("StarId");
    localStorage.removeItem("user");
    history.push("/");
    window.location.reload();
  return (
    <h1>Log out</h1>
  );
}